exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-d8d15b64] .el-form-item__content {\n    line-height: unset;\n    position: relative;\n    font-size: 14px;\n}\n.cover-image[data-v-d8d15b64]{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 220px;\n}\n.cover-image-item[data-v-d8d15b64] {\n  margin-right: 10px;\n  width: 112px;\n  height: 167px;\n}\n", ""]);

// exports
